const DEFAULT_PROP_OPTIONS = {
  mutation: true,
  getter: true,
  action: true
}

export default class StoreDefinition {
  constructor (store) {
    this._store = Object.assign({
      state: {},
      getters: {},
      actions: {},
      mutations: {},
      namespaced: true
    }, store)

    this._lastSetup = null
  }

  /**
   *
   * @param name
   * @param defaultValue
   * @param options
   * @returns {StoreDefinition}
   */
  prop (name, defaultValue = null, options = {}) {
    options = Object.assign({}, DEFAULT_PROP_OPTIONS, options)
    const dataName = name.charAt(0).toUpperCase() + name.slice(1)

    // define default
    this._store.state[name] = defaultValue

    // names for props
    const setup = {
      prop: name,
      dataName,
      mutation: typeof options.mutation === 'string'
        ? options.mutation
        : 'set' + dataName,

      getter: typeof options.getter === 'string'
        ? options.getter
        : name,

      action: typeof options.action === 'string'
        ? options.action
        : 'set' + dataName
    }

    if (options.mutation) {
      this._store.mutations[setup.mutation] = (state, data) => {
        state[name] = data
      }
    }

    if (options.getter) {
      this._store.getters[setup.getter] = (state) => {
        return state[name]
      }
    }

    if (options.action) {
      this._store.actions[setup.action] = ({ commit }, data) => {
        return commit(setup.mutation, data)
      }
    }

    this._lastSetup = setup

    return this
  }

  /**
   *
   * @param getterName
   * @param handler
   * @returns {StoreDefinition}
   */
  get (getterName, handler) {
    if (arguments.length === 1) {
      handler = getterName
      getterName = this._lastSetup.getter
    }

    this._store.getters[getterName] = handler
    return this
  }

  /**
   *
   * @param actionName
   * @param handler
   * @returns {StoreDefinition}
   */
  action (actionName, handler) {
    if (arguments.length === 1) {
      handler = actionName
      actionName = this._lastSetup.action
    }

    this._store.actions[actionName] = handler
    return this
  }

  /**
   *
   * @param obj
   * @returns {StoreDefinition}
   */
  merge (obj) {
    Object.keys(obj).forEach((key) => {
      Object.assign(this._store[key], obj[key])
    })

    return this
  }

  /**
   *
   * @param obj
   * @returns {any}
   */
  end (obj = {}) {
    this.merge(obj)
    return this._store
  }
}
